import * as React from 'react';
import { connect } from 'react-redux';
import * as AlertModule from 'Modules/AlertModule';
import * as ViewManagementModule from 'Modules/ViewManagementModule';
import { withTranslation  } from 'react-i18next';
import * as Dictionary from 'Models/Dictionary';
import { ParentDetails, CustomProps, IParentDetailsProps } from 'components/Layout/DetailsSidebar/ParentDetails';

interface IP extends IParentDetailsProps {
    history: any;
}

type ConnectedP = {
    alertStore: AlertModule.Types.AlertStore;
};
type DispatchedP = {
    deleteAlert: (alertId: number) => Function;
    setActiveAlert: (alert: AlertModule.Types.AlertDefinitionDto) => Function;
    showPopup: (popupData: ViewManagementModule.Types.Popup) => Function;
    t?: (key: string) => string;
};
type S = {};
class AlertListDetails extends ParentDetails<IP & ConnectedP & DispatchedP, S> {
    public getCustomProps(): CustomProps {
        const { PopupType } = ViewManagementModule.VMEnumTypes;
        const { alertStore } = this.props;
        const {
            alertStore: { activeAlert }
        } = this.props;
        const { ALERTS } = ViewManagementModule.EnumTypes.Page;
        return {
            ...(this.props as any),
            setActiveEl: (el: any) => {
                return this.props.setActiveAlert(el);
            },
            deleteEl: (id: number) => {
                return this.props.deleteAlert(id || null);
            },
            elStore: alertStore,
            activeEl: activeAlert,
            redirectUrlEdit: `${Dictionary.PageUrl.get(ALERTS)}/${activeAlert ? activeAlert.id : ''}`,
            redirectUrlAdd: `${Dictionary.PageUrl.get(ALERTS)}/add`,
            popupTypeDelete: PopupType.DELETE_ALERT,
            labelAdd: this.props.t('addAlert'),
            labelEdit: this.props.t('edit'),
            labelDelete: this.props.t('delete')
        };
    }
}

function mapStateToProps(state: any): ConnectedP {
    return {
        alertStore: state.alertStore
    };
}
function mapDispachToProps(dispatch: any): DispatchedP {
    return {
        deleteAlert: alertId => dispatch(AlertModule.Actions.deleteAlert(alertId)),
        setActiveAlert: (alert: AlertModule.Types.AlertDefinitionDto) => dispatch(AlertModule.Actions.setActiveAlert(alert)),
        showPopup: (popupData: ViewManagementModule.Types.Popup) => dispatch(ViewManagementModule.Actions.showPopup(popupData))
    };
}
export default withTranslation (['carDetails'])(
    connect(
        mapStateToProps,
        mapDispachToProps
    )(AlertListDetails) as React.ComponentType<any>
);



// WEBPACK FOOTER //
// ./src/components/Layout/DetailsSidebar/AlertListDetails.tsx